<div *ngIf="treatyNewsInfos" class="childAccordion-container">
  <mat-accordion class="childAccordion">
    <mat-expansion-panel *ngFor="let treatyNews of treatyNewsInfos">
      <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
        <div class="content">{{treatyNews.newsHeading}}</div> <div class="date">{{treatyNews.modifiedDate | date:'dd MMMM yyyy'}}</div>
      </mat-expansion-panel-header>
        <particle-dynamic-html [content]="treatyNews.newsContent"></particle-dynamic-html>
        {{treatyNews.updateDate | date: 'dd MMMM yyyy'}}
    </mat-expansion-panel>
  </mat-accordion>
</div>

